import styles from './theme-preview.scss';

const getColor = (theme, variable) => {
  // if color is shown in preview but not configurable then use the default CSS variable
  return theme.cssVars[variable] || `var(${variable})`;
};

export const ThemePreview = ({ theme, disabled }) => {
  if (disabled) {
    return <div className={styles.container}></div>;
  }

  const primaryColor = getColor(theme, '--primary-color');
  const secondaryColor = getColor(theme, '--secondary-color');
  const followUpColor = getColor(theme, '--follow-up-color');
  const followUpColorLight = getColor(theme, '--follow-up-color-light');
  const followUpColorDark = getColor(theme, '--follow-up-color-dark');
  const chatIconBackgroundColor = getColor(theme, '--chat-icon-background-color');
  const headerLogoBackgroundColor = getColor(theme, '--header-logo-background-color');
  const accentColor = getColor(theme, '--accent-color');
  const accentLightColor = getColor(theme, '--accent-light-color');
  const fontColor = getColor(theme, '--font-color');
  const fontLightColor = getColor(theme, '--font-light-color');
  const secondaryLightColor = getColor(theme, '--secondary-light-color');
  // we need to scale down the logo height (expressed in px) by half to match the design
  const maxLogoHeight = parseInt(theme.cssVars['--max-logo-height']?.replace('px', '')) / 2 || 11;

  return (
    <div className={styles.container}>
      <div className={styles.sidebar} style={{ backgroundColor: primaryColor }}>
        <div className={styles.logoFull} style={{ backgroundColor: headerLogoBackgroundColor }}>
          <img
            className={styles.logoFull}
            src={theme.assets.logoFull}
            alt="full logo"
            style={{ maxHeight: maxLogoHeight + 'px' }}
          />
        </div>
        <div className={styles.kgButton} style={{ backgroundColor: secondaryColor }}></div>
      </div>
      <div className={styles.mainBackground} style={{ backgroundColor: accentLightColor }}>
        <div className={styles.backgroundContainer}>
          <div className={styles.answerLeft}>
            <div className={styles.chatIconCircle} style={{ backgroundColor: chatIconBackgroundColor }}>
              <div className={styles.logoShort}>
                <img className={styles.logoShort} src={theme.assets.logoShort} alt="short logo" />
              </div>
            </div>
          </div>
          <div className={styles.answer} style={{ backgroundColor: accentColor, borderColor: followUpColor }}>
            <div className={styles.answerText} style={{ color: fontColor }}>
              ...
            </div>
            <div className={styles.followUp} style={{ backgroundColor: followUpColorLight }}>
              <span className={styles.followUpText} style={{ color: followUpColorDark }}>
                FollowUp
              </span>
            </div>
          </div>
          <div className={styles.question} style={{ backgroundColor: secondaryLightColor }}>
            <div className={styles.questionText} style={{ color: fontLightColor }}>
              ...
            </div>
          </div>
        </div>
      </div>
      <div className={styles.input} style={{ backgroundColor: accentColor }}>
        <div className={styles.askButton} style={{ background: primaryColor }}></div>
      </div>
    </div>
  );
};
